import React from 'react';
import { Modal, Box, Typography, Divider, Chip } from '@mui/material';
import { CommunicationType } from '../../../data/CommunicationType';
import IconList from "../../../data/account/socialMediaIcons";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    selectedCommunication: CommunicationType | null;
}

const DetailModal: React.FC<Props> = ({ isOpen, onClose, selectedCommunication }) => {
    if (!selectedCommunication) return null;

    // Find the corresponding icon from socialMediaIcons.tsx
    const renderIcon = (iconString: string) => {
        const IconComponent = IconList[iconString]; // Fetch icon from socialMediaIcons.tsx
        return IconComponent ? <IconComponent /> : iconString; // Return icon or fallback to string if not found
    };

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box
                sx={{
                    padding: 3,
                    backgroundColor: 'white',
                    margin: 'auto',
                    marginTop: '10%',
                    width: 400,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h6" gutterBottom>
                    Communication Type Details
                </Typography>
                <Divider sx={{ marginBottom: 2 }} />
                <Typography variant="subtitle1">
                    <strong>Type:</strong> {selectedCommunication.comType}
                </Typography>
                <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <strong>Icon:</strong> {renderIcon(selectedCommunication.icon)}
                </Typography>
                <Typography variant="subtitle1" sx={{ marginTop: 2 }}>
                    <strong>Tags:</strong>
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        marginTop: 1,
                    }}
                >
                    {selectedCommunication.tags && selectedCommunication.tags.length > 0 ? (
                        selectedCommunication.tags.map((tag) => (
                            <Chip
                                key={tag}
                                label={tag}
                                sx={{
                                    backgroundColor: "#2196F3",
                                    color: "white",
                                    "& .MuiChip-label": {
                                        color: "white !important",
                                        fontWeight: "bold",
                                    },
                                    "& .MuiChip-deleteIcon": {
                                        color: "white",
                                    },
                                }}
                            />
                        ))
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            No Tags Available
                        </Typography>
                    )}
                </Box>
            </Box>
        </Modal>
    );
};

export default DetailModal;